import { render, staticRenderFns } from "./relatedDefault.vue?vue&type=template&id=5d4a96f8"
import script from "./relatedDefault.vue?vue&type=script&lang=js"
export * from "./relatedDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmallCard: require('/opt/build/repo/frontend/components/cards/smallCard.vue').default})
